<template>
  <div>
    <el-row>
      <el-steps class="elsteps" align-center :active="active" finish-status="success">
        <el-step title="填写手机" />
        <el-step title="验证手机" />
        <el-step title="更新密码" />
      </el-steps>
      <el-row class="formtext">
        <el-form label-position="top" :model="findForm">
          <el-form-item v-if="active===0" label="电话号码">
            <el-input v-model="findForm.phone" />
          </el-form-item>
          <el-form-item v-if="active===1" label="验证码">
            <el-input v-model="findForm.authCode" />
          </el-form-item>
          <el-form-item v-if="active===2" label="新密码">
            <el-input v-model="findForm.newPdw" type="password" />
          </el-form-item>
          <el-form-item v-if="active===2" label="确认密码">
            <el-input v-model="findForm.affirmPdw" type="password" />
          </el-form-item>
        </el-form>
      </el-row>
    </el-row>
    <el-row v-if="active!==3" class="butrow">
      <el-button style="margin-top: 22px;" @click="next">
        {{ ButText }}
      </el-button>
      <el-tag v-if="active===3" :type="success" effect="dark">
        密码修改成功！
      </el-tag>
    </el-row>
  </div>
</template>
<script>
import { updatePasswordInForgetProcess, sendVerifyCode, isVerifyCodeOK } from '../utils/httpMain.js'
export default {
  data() {
    return {
      active: 0,
      ButText: '下一步',
      findForm: {
        phone: '',
        authCode: '',
        newPdw: '',
        affirmPdw: ''

      }
    }
  },
  watch: {
    active(val) {
      if (val === 0) {
        this.ButText = '下一步'
      } else if (val === 1) {
        this.ButText = '下一步'
      } else if (val === 2) {
        this.ButText = '修改'
      }
    }
  },
  methods: {
    next() {
      switch (this.active) {
        case 0:
          if (this.findForm.phone === '') {
            this.$message({
              message: '电话号码不能为空',
              type: 'warning'
            })
            return true
          }
          sendVerifyCode(this.findForm.phone, 0).then(Response => {
            console.log(Response)
            if (Response.data.data >= 0) {
              this.$message({
                message: '手机验证成功，短信已经发送到你的手机。',
                type: 'success'
              })
              this.active = 1
            } else {
              this.$message({
                message: '手机号码输入有误请重新输入',
                type: 'warning'
              })
              this.active = 0
              return true
            }
          })
          break
        case 1:
          if (this.findForm.authCode === '') {
            this.$message({
              message: '验证码不能为空',
              type: 'warning'
            })
            return true
          }
          isVerifyCodeOK(this.findForm.phone, this.findForm.authCode).then(Response => {
            console.log(Response)
            if (Response.data.data === true) {
              this.$message({
                message: '验证成功',
                type: 'success'
              })
              this.active = 2
            } else {
              this.$message({
                message: '验证失败',
                type: 'warning'
              })
              return true
            }
          })
          break
        case 2:
          console.log(this.findForm.newPdw, this.findForm.affirmPdw)
          if (this.findForm.affirmPdw === '' || this.findForm.newPdw !== this.findForm.affirmPdw) {
            this.$message({
              message: '两次输入密码不一致',
              type: 'warning'
            })
            return true
          }
          var model = {
            userMobile: this.findForm.phone,
            userNewPassword: this.findForm.newPdw
          }
          updatePasswordInForgetProcess(model).then(Response => {
            console.log(Response)
            if (Response.data.data === 0) {
              this.$message({
                message: '密码已经修改请重新登录',
                type: 'success'
              })
              this.active = 3
              // window.location.reload()
              setTimeout(() => {
                this.centerDialogVisible = false
              }, 2000)
            }
          })
          break
      }
    }
  }
}
</script>
<style scoped>
.elsteps{
  margin-bottom: 50px;
}
.formtext{
  margin-left: 20px;
  margin-right: 20px;
}
.butrow{
  text-align:center;
}
</style>

